import React, { useEffect } from "react";
import NavBarComponent from "../components/navBar/NavBarComponent.js";
import FooterComponent from "../components/home/FooterComponent.js";
import PricingPlansGrid from "../components/pricing/PricingPlansGrid.jsx";
import { handleSubmission } from "../models/notifications";

function PricingPlansPage() {
  useEffect(() => {
    window.gtag("event", "pricing_plans_page_visit", {
      event_callback: () => {
        window.gtag("get", "G-8G0V7WWP5L", "client_id", (clientId) => {
          if (!window.pricingPlansPageVisitEventSent) {
            window.pricingPlansPageVisitEventSent = true;
            handleSubmission(
              { type: "pricing_plans_page_visit", clientId },
              () => {}
            );
          }
        });
      },
    });
  }, []);

  return (
    <div className="updated-page-wrapper">
      <NavBarComponent />
      <section className="section-68" style={{ paddingTop: "80px", paddingBottom: "80px" }}>
        <PricingPlansGrid />
      </section>
      <FooterComponent />
    </div>
  );
}

export default PricingPlansPage;
